import { render, staticRenderFns } from "./dropdown_button_group.vue?vue&type=template&id=a4ec064e&scoped=true&"
import script from "./dropdown_button_group.vue?vue&type=script&lang=js&"
export * from "./dropdown_button_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec064e",
  null
  
)

export default component.exports